<template>
  <div>
    <section id="filters">
      <vs-divider position="left">Where</vs-divider>
      <spatial-filter :force-active="true" />
      <vs-divider position="left">What</vs-divider>
      <div class="section-container">
        <vs-select v-model="selectedType" @change="onTypeChange">
          <vs-select-item
            v-for="(type, index) in types"
            :key="index"
            :value="type"
            :text="type.name"
          />
        </vs-select>
        <div class="button">
          <vs-button
            type="filled"
            size="small"
            icon="search"
            color="#19535F"
            @click="searchDevices()"
            >Search Devices</vs-button
          >
        </div>
      </div>
    </section>
    <section class="datatable">
      <devices-table
        :devices="devices"
        :is-radar="isRadarType"
        @onViewData="showDeviceData"
      ></devices-table>
    </section>
  </div>
</template>
<script>
import { getBuoysFromPoint } from "@/api/sensors";
import { getRadarsFromPoint } from "@/api/mercurio";
import SpatialFilterControl from "@/components/ui/SpatialFilterControl";
import TableDevices from "@/components/TableDevices";
import { BUOYS_TYPES, BTM_PANELS } from "@/constants.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "devices-table": TableDevices,
    "spatial-filter": SpatialFilterControl
  },
  data() {
    return {
      devices: [],
      selectedType: {},
      types: BUOYS_TYPES.sort(this.$_utilsMixin_sortArray("name"))
    };
  },
  computed: {
    ...mapState("map", {
      marker: state => state.marker
    }),
    isRadarType() {
      return this.selectedType.id === 99;
    }
  },
  mounted() {
    this.selectedType = this.types[0]; //select first
  },
  methods: {
    ...mapActions({
      toggleLoading: "toggleLoading",
      setActiveProduct: "setActiveProduct",
      setActiveDevice: "setActiveDevice",
      setBTMDataHubActivePanel: "setBTMDataHubActivePanel"
    }),
    searchDevices() {
      if (this.isRadarType) {
        this.searchRadarsFromPoint(this.marker);
      } else {
        this.searchBuoysOfTypeFromPoint(this.marker, this.selectedType.id);
      }
    },
    searchBuoysOfTypeFromPoint(marker, typeId) {
      this.toggleLoading(true);
      getBuoysFromPoint(marker)
        .then(buoys => {
          const filteredBuoys = buoys.filter(
            buoy => buoy.buoyTypeId === typeId
          );
          this.devices = filteredBuoys;
        })
        .catch(error => {
          this.$_utilsMixin_notify("Error", error, 2);
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    searchRadarsFromPoint(marker) {
      this.toggleLoading(true);
      getRadarsFromPoint(marker)
        .then(radars => {
          this.devices = radars;
        })
        .catch(error => {
          this.$_utilsMixin_notify("Error", error, 2);
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    onTypeChange() {
      this.devices = [];
    },
    showDeviceData(selectedDevice) {
      selectedDevice.isRadar = this.isRadarType; //add prop to know if its radar or buoy
      this.setActiveDevice(selectedDevice);
      this.setBTMDataHubActivePanel(BTM_PANELS.DATAHUB.VIEWER);
    }
  }
};
</script>
<style scoped>
.search-button {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.button {
  display: flex;
  justify-content: flex-end;
}
.datatable {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
